<div class="item">
	<skl-spinner [size]="20" [offset]="{ top: '-4px', left: '-30px' }"></skl-spinner>
	{{text}}
</div>